export const SANTE_SECURITE_AU_TRAVAIL_CONTENT = 'sante-au-travail'
export const EGAPRO_CONTENT = 'egapro'
export const HANDICAP_CONTENT = 'handicap'
export const HANDIPSY_CONTENT = 'handipsy'
